import script from "./Requirements.vue?vue&type=script&setup=true&lang=ts"
export * from "./Requirements.vue?vue&type=script&setup=true&lang=ts"

import "./Requirements.vue?vue&type=style&index=0&id=161472da&lang=css"

const __exports__ = script;

export default __exports__